export default "__VITE_ASSET__CuotF5_x__"